import React, { useEffect, useState } from "react";
import {
  downloadPaymentFile,
  getBlock,
  getDistrict,
  getGPbyBlock,
  reject_vendor_payment,
  approveVendor,
  dscSignature,
  getVenderData,
  getAllVendorAvailable,
  getAllVendorPageCount,
  rejectVendor,
} from "../../api/User";
import loader from "../../images/ajax-loader.gif";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Container, Modal } from "react-bootstrap";
import DSCValidationPage from "../DSCValidation";
import { FiArrowLeftCircle } from "react-icons/fi";
import { FiArrowRightCircle } from "react-icons/fi";

function VendorApproval({ token, userDetail, userData }) {
  const [showTable, setShowTable] = useState(true);
  const [districtData, setDistrictData] = useState([]);
  const [districtType, setDistrictType] = useState("");
  const [blockData, setBlockData] = useState([]);
  const [blockType, setBlockType] = useState("");
  const [GPData, setGPData] = useState([]);
  const [GPType, setGPType] = useState("");
  const [tableData, setTableData] = useState([]);
  const [toReject, setToReject] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isReadonly, setIsReadonly] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [selectedValueName, setSelectedValueName] = useState("");
  const [loadingBlock, setLoadingBlock] = useState(true);
  const [visibleOptions, setVisibleOptions] = useState([]);
  const [districtName, setDistrictName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [GpName, setGpName] = useState("");
  const MySwal = withReactContent(Swal);
  const [DSCModalShow, setDSCModalShow] = useState(false);
  const handleDSCClose = () => setDSCModalShow(false);
  const [show, setShow] = useState(false);
  const [vendorId, setVendorId] = useState("");
  const role = userDetail.role_id;
  const id = userDetail?.user_id;
  const [pageVal, setPageVal] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState("");


  const goToPreviousPage = () => {
    if (pageVal > 1) {
      setPageVal(pageVal - 1);
      const newPage = pageVal - 1;
      getAllVendorDetails(newPage);
    }
  };

  const goToNextPage = () => {
    if (pageVal < totalPageCount) {
      setPageVal(pageVal + 1);
      const newPage = pageVal + 1;
      getAllVendorDetails(newPage);
    }
  };


  const getAllVendorDetails =(newPage)=>{
    const data2 = {
      role: userDetail.role_id,
      district: districtType,
      block: blockType,
      village: GPType,
      page: newPage,
    };
    getAllVendorAvailable(token, data2)
      .then((res) => {
        if (res.status === "success") {
          setTableData(res.data);
        } else {
          console.error("Failed to get  details:", res.error);
        }
      })
      .catch((err) => {
        console.error("Error fetching  details:", err);
      });
  }

  useEffect(() => {
    const options = [];
    if (role === 6 || role === 7) {
      options.push("gp");
      setSelectedValue("gp");
      setSelectedValueName("Gram Panchayat");
      setIsReadonly(true);
    } else if (role === 8 || role === 9) {
      options.push("ps");
      setSelectedValue("ps");
      setSelectedValueName("Panchayat Samiti");
      setIsReadonly(true);
    } else if (role === 10 || role === 11) {
      options.push("zp");
      setSelectedValue("zp");
      setSelectedValueName("Zila Parishad");
      setIsReadonly(true);
    } else {
      options.push("sab", "gp", "ps", "zp");
      setSelectedValue("");
      setIsReadonly(false);
    }
    // getAllVendorAvailable(token);

    setVisibleOptions(options);
  }, [role]);

  const fetchDistrictData = async () => {
    try {
      const res = await getDistrict(
        token,
        userDetail.role_id,
        userDetail.user_id
      );
      setDistrictData(res.data);
      if (res.data.length == 1) {
        setDistrictType(res.data[0].district_code);
        setDistrictName(res.data[0].district_name);
        console.log(res.data[0].district_code);
        fetchBlockData(res.data[0].district_code);
        
      } else {
        setDistrictType(res.data.district);
        setDistrictName(res.data.district_name);
        fetchBlockData(res.data.district_code);
        if(res.data.length > 1) {
          setIsReadonly(false)
        }
      }
      if (role == 11) {
        const data = {
          role: userDetail.role_id,
          district: res.data[0].district_code,
          block: blockType,
          village: GPType,
          page:pageVal
        };getAllVendorPageCount(token, data).then((res) => {
          setTotalPageCount(res.data);
        getAllVendorAvailable(token, data)
          .then((res) => {
            if (res.status === "success") {
              setTableData(res.data);
            } else {
              console.error("Failed to get  details:", res.error);
            }
          })
          .catch((err) => {
            console.error("Error fetching  details:", err);
          });})
      }
    } catch (error) {
      console.error("Error fetching district data:", error);
    }
  };

  const fetchBlockData = async (districtCode) => {
    const data = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district: districtCode,
    };

    try {
      const res = await getBlock(token, data);
      setBlockData(res.user);

      if (res.user.length == 1) {
        setBlockType(res.user[0].block_code);
        setBlockName(res.user[0].block_name);
        console.log(res.user[0].block_code, data.district);
        fetchVillageData(res.user[0].block_code, data.district);
      }

      if (role == 9) {
        const data2 = {
          role: userDetail.role_id,
          district: districtCode,
          block: res.user[0].block_code,
          village: GPType,
          page:pageVal
        };
        getAllVendorPageCount(token, data2).then((res) => {
          setTotalPageCount(res.data);
        getAllVendorAvailable(token, data2)
          .then((res) => {
            if (res.status === "success") {
              setTableData(res.data);
            } else {
              console.error("Failed to get  details:", res.error);
            }
          })
          .catch((err) => {
            console.error("Error fetching  details:", err);
          });})
      }
    } catch (error) {
      console.error("Error fetching block data:", error);
    }
  };

  const fetchVillageData = async (blockcode, district_code) => {
    setLoadingBlock(true);
    console.log(
      blockcode,
      district_code,
      userDetail.user_id,
      userDetail.role_id
    );

    const data1 = {
      role_id: userDetail.role_id,
      id: userDetail.user_id,
      district_code: district_code,
      block_code: blockcode,
    };
    try {
      await getGPbyBlock(token, data1)
        .then((res) => {
          setGPData(res.data);
          console.log(res.data[0].VillageId, "hello");
          setIsReadonly(true);
          if (role == 7) {
            const data2 = {
              role: userDetail.role_id,
              district: district_code,
              block: blockcode,
              village: res.data[0].VillageId,
              page:pageVal
            };getAllVendorPageCount(token, data2).then((res) => {
              setTotalPageCount(res.data);
            getAllVendorAvailable(token, data2)
              .then((res) => {
                if (res.status === "success") {
                  setTableData(res.data);
                } else {
                  console.error("Failed to get  details:", res.error);
                }
              })
              .catch((err) => {
                console.error("Error fetching  details:", err);
              });})
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching block data:", error);
    } finally {
      setLoadingBlock(false);
    }
  };

  const handleEntityChange = async (e) => {
    const newValue = e?.target?.value || selectedValue;

    setSelectedValue(newValue);
    await fetchDistrictData();
  };

  useEffect(() => {
    if (selectedValue) {
      handleEntityChange();
    }
  }, [selectedValue]);

  const handleDistrictChange = async (e) => {
    setDistrictType(e.target.value);
    const data = {
      role_id: role,
      id: id,
      district: e.target.value,
    };

    try {
      await getBlock(token, data)
        .then((res) => {
          setBlockData(res.user);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const handleBlockChange = async (e) => {
    setBlockType(e.target.value);
    const data = {
      role_id: role,
      id: id,
      district_code: districtType,
      block_code: e.target.value,
    };

    try {
      await getGPbyBlock(token, data)
        .then((res) => {
          setGPData(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleGPChange = (e) => {
    setGPType(e.target.value);
    console.log(e.target.value);
    e.preventDefault();
    setLoading(true);

    const data = {
      role: userDetail.role_id,
      district: districtType,
      block: blockType,
      village: e.target.value,
      page:pageVal
    };getAllVendorPageCount(token, data).then((res) => {
      setTotalPageCount(res.data);
    getAllVendorAvailable(token, data)
      .then((res) => {
        if (res.status === "success") {
          setTableData(res.data);
        } else {
          console.error("Failed to get  details:", res.error);
        }
      })
      .catch((err) => {
        console.error("Error fetching  details:", err);
      });
    setTimeout(() => {
      setShowTable(true);
      setLoading(false);
    }, 1000);})
  };
  const handleApproveVendor = async (data) => {
    try {
      setLoading(true);
      const data = {
        role: userDetail.role_id,
        vendor_id: vendorId,
        district: districtType,
        block: blockType,
        village: GPType,
      };
      const result = await approveVendor(token, data);
      if (result.status == "success") {
        MySwal.fire({
          icon: "success",
          title: "Vendor Approved Successfully!",
        });

        setTableData((prevData) =>
          prevData.map((item) =>
            item.vendor_id == vendorId ? { ...item, is_approve: 1 } : item
          )
        );
      } else {
        MySwal.fire({
          icon: "error",
          title: "Failed to Approve Vendor",
          text: result.message || "An error occurred.",
        });
      }
    } catch (error) {
      console.error("Error approving vendor:", error);
      MySwal.fire({
        icon: "error",
        title: "Error Approving Vendor",
        text: "An error occurred while trying to approve the vendor.",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const postData = {
      file_name: "Voucher_147064_maker_signed",
      mnc: "checker",
    };
    try {
      await dscSignature(token, postData).then((res) => {
        if (res.indexOf("maker_signed_checker_signed") !== -1) {
          MySwal.fire({
            icon: "success",
            title: "PDF signed Successfully!!",
          });
        }
      });
    } catch (err) {
      console.error("Error uploading voucher:", err);
      MySwal.fire({
        icon: "warning",
        title: "Error Signing the PDF",
      });
    }
  };
  const selectAllRows = (event) => {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = event.target.checked;
    });
  };
  const handleShow = (data, village) => {
    setGPType(village);
    setDSCModalShow(true);
    setVendorId(data);
    setShow((prevState) => !prevState);
  };

  const [showRejectConsentModal,setShowRejectConsentModal] =useState(false);
  const [venID,setVenID]= useState("");
  const [vill,setVill] = useState("");

  const handleReject = (id,village) =>{

    setShowRejectConsentModal(true);
    setVenID(id);
    setVill(village)

  }
  const handleRejectModal =async()=>{

    console.log(id,vill);
    const data = {
      vendor_id: venID,
      district: districtType,
      block: blockType,
      village: vill,
    }
    const res = await rejectVendor(token,data)
    if (res.status=="success"){
      const data = {
      role: userDetail.role_id,
      district: districtType,
      block: blockType,
      village: vill,
      page:pageVal
      }
      getAllVendorAvailable(token,data)
      .then((res) => {
        if (res.status === "success") {
          setTableData(res.data);
        } else {
          console.error("Failed to get  details:", res.error);
        }
      })
      .catch((err) => {
        console.error("Error fetching  details:", err);
      });
    }
    setShowRejectConsentModal(false)
  }
  

  return (
    <>
      <div id="loading-coupon" style={{ display: loading ? "flex" : "none" }}>
        <img id="loading-image" src={loader} alt="Loading..." />
      </div>
      <div className="container-fluid col px-2 px-md-4">
        <div className="my-5 col-12 d-flex justify-content-between align-items-center">
          <h5>
            <strong>Vendor Approval</strong>
          </h5>
        </div>
        <form className="filter" id="myform">
          <div className="row mb-4">
            <div className="col-4">
              <label htmlFor="type" className="form-label">
                Entity {<span style={{ color: "red" }}>*</span>}{" "}
              </label>
              <select
                name="type"
                id="type"
                className="type form-select"
                value={selectedValue}
                onChange={handleEntityChange}
                disabled={isReadonly}
              >
                <option value="" disabled>
                  Select Type
                </option>
                {visibleOptions.includes("sab") && (
                  <option value="sab">All</option>
                )}
                {visibleOptions.includes("gp") && (
                  <option value="gp">Gram Panchayat</option>
                )}
                {visibleOptions.includes("ps") && (
                  <option value="ps">Panchayat Samiti</option>
                )}
                {visibleOptions.includes("zp") && (
                  <option value="zp">Zila Parishad</option>
                )}
                {visibleOptions.includes("zp") && (
                  <option value="zp">District</option>
                )}
              </select>
            </div>
          </div>
          <div className="row d-flex">
            <div style={{ width: "33.33%" }}>
              <label className="form-label">
                District  {<span style={{ color: "red" }}>*</span>}
              </label>
              {districtData.length == 1 ? (
                <input
                  className="form-control"
                  type="text"
                  value={districtData[0]?.district_name}
                  disabled={isReadonly}
                  onInput={handleDistrictChange}
                />
              ) : (
                <select
                  name="district"
                  className="common-input form-select"
                  required
                  value={districtType}
                  onChange={handleDistrictChange}
                >
                  <option value="">Select District</option>
                  
{districtData
  .filter((district, index, self) => 
    index === self.findIndex(d => d.district_code === district.district_code)
  )
  .map((district, index) => (
    <option key={index} value={district.district_code}>
      {district.district_name}
    </option>
  ))}
                </select>
              )}
            </div>
            {role == 6 || role==7 || role==8 || role==9 ? (
              <div className style={{ width: "33.33%" }}>
                <label className="form-label">
                  Block {<span style={{ color: "red" }}>*</span>}
                </label>
                {blockData?.length == 1 ? (
                  <input
                    name="block"
                    className="form-control"
                    type="text"
                    value={blockData[0]?.block_name}
                    disabled={isReadonly}
                  />
                ) : (
                  <select
                    name="block"
                    className="common-input form-select"
                    value={blockType}
                    required
                    onChange={handleBlockChange}
                  >
                    <option value="">Select Block</option>
                    {blockData?.map((block, index) => (
                      <option key={index} value={block.block_code}>
                        {block.block_name}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            ) : (
              ""
            )}
            {role == 6 || role==7 ? (
              <div className style={{ width: "33.33%" }}>
                <label className="form-label">
                  Gram Panchayat {<span style={{ color: "red" }}>*</span>}
                </label>
                {GPData?.length == 1 ? (
                  <input
                    name="GP"
                    className="form-control"
                    type="text"
                    value={
                      GPData && GPData.length > 0 ? GPData[0].VillageName : ""
                    }
                    disabled={isReadonly}
                  />
                ) : (
                  <select
                    name="district"
                    className="common-input form-select"
                    defaultValue={GpName}
                    onChange={handleGPChange}
                    required
                  >
                    <option value="">Select Gram Panchayat</option>
                    {GPData?.map((gp, index) => (
                      <option key={index} value={gp.VillageId}>
                        {gp.VillageName}
                      </option>
                    ))}
                  </select>
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        </form>
        <div className="">
          <div className="mb-4 mt-4 col-12 d-flex justify-content-start align-items-center">
            <h5 className="">Vendor/Labour Authorization</h5>
          </div>

          <div style={{ overflowX: "auto" }} className="mb-5">
            <table
              className="table table-striped table-bordered justify-content-center align-items-center"
              aria-label="simple table"
            >
              <thead>
                <tr align="center" style={{ fontSize: "16px" }}>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    <input type="checkbox" onChange={selectAllRows} />
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    S. No.
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Vendor Code
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Vendor Name
                  </th>
                  <th
                    align="center"
                    style={{ whiteSpace: "nowrap", backgroundColor: "#00bfff" }}
                  >
                    Account Number
                  </th>
                  <th
                    align="center"
                    style={{
                      width: "5rem",
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                    }}
                  >
                    Approval
                  </th>
                  <th
                    align="center"
                    style={{
                      width: "5rem",
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                    }}
                  >
                    Reject
                  </th>
                  {/* <th
                    align="center"
                    style={{
                      width: "5rem",
                      whiteSpace: "nowrap",
                      backgroundColor: "#00bfff",
                    }}
                  >
                    Deactivate
                  </th> */}
                </tr>
              </thead>
              {showTable && (
                <tbody>
                  {!tableData || tableData.length === 0 ? (
                    <tr style={{ fontSize: "16px", color: "grey" }}>
                      <td colSpan="9" style={{ textAlign: "center" }}>
                        No data available
                      </td>
                    </tr>
                  ) : (
                    tableData.map((data, index) => (
                      <tr
                        key={index}
                        align="center"
                        style={{ fontSize: "16px" }}
                      >
                        <td>
                          <input type="checkbox" />
                        </td>
                        <td component="th">{index + 1}</td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data.vendor_code}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data.vendor_name}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }} align="center">
                          {data.account_number}
                        </td>

                        <td style={{ whiteSpace: "nowrap" }}>
                          {data.is_approve == 1 ? (
                            "Approved"
                          ) : (
                            <button
                              className="btn"
                              onClick={() =>
                                handleShow(data.vendor_id, data.village)
                              }
                            >
                              Approve
                            </button>
                          )}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                        <button
                              className="btn " style={{backgroundColor:data.is_approve == 1 ? "grey":"red"}}
                              
                              onClick={() =>
                                handleReject(data.vendor_id, data.village)
                              }
                              disabled = {data.is_approve == 1 ? true:false}
                            >
                              Reject
                            </button>
                        </td>
                        {/* <td style={{ whiteSpace: "nowrap" }}>
                          {data.is_approve == 1 ? (
                             <button
                             className="btn"
                             onClick={() =>
                               handleShow(data.vendor_id, data.village)
                             }
                           >
                             Deactivate
                           </button>
                          ) : (
                            data.is_approve == 0 ? "-" : "Rejected" 
                          )}
                        </td> */}
                      </tr>
                    ))
                  )}
                </tbody>
              )}
            </table>
            <div className="d-flex justify-content-end">
              <div className="px-5 pb-4 d-flex">
                <div
                  onClick={goToPreviousPage}
                  disabled={pageVal === 1}
                  className={` flex ${
                    pageVal === 1 ? "bg-gray-200 " : "bg-blue-500 text-blue"
                  }`}
                  style={{ cursor: pageVal === 1 ? "not-allowed" : "pointer" }}
                >
                  <FiArrowLeftCircle size={"2rem"} />
                </div>

                {pageVal > 1 && (
                  <span
                    onClick={() => setPageVal(pageVal - 1)}
                    className="cursor-pointer px-3 py-1 rounded-md bg-gray-100"
                    style={{ fontSize: "13px" }}
                  >
                    {pageVal - 1}
                  </span>
                )}

                <span
                  className="px-3 py-0 rounded-md bg-blue-500 font-bold"
                  style={{ fontSize: "18px" }}
                >
                  {pageVal}
                </span>

                {pageVal < totalPageCount && (
                  <span
                    onClick={() => setPageVal(pageVal + 1)}
                    className="cursor-pointer px-3 py-1 rounded-md bg-gray-100"
                  >
                    {pageVal + 1}
                  </span>
                )}

                <div
                  onClick={goToNextPage}
                  disabled={pageVal === totalPageCount}
                  className={`${
                    pageVal === totalPageCount
                      ? "bg-gray-200"
                      : "bg-blue-500 text-gray"
                  }`}
                  style={{
                    cursor: pageVal === totalPageCount ? "not-allowed" : "pointer",
                  }}
                >
                  <FiArrowRightCircle size={"2rem"} />{" "}
                </div>
              </div>
            </div>
            <Modal show={DSCModalShow} onHide={handleDSCClose} size="xl">
              <Modal.Header closeButton>
                <Modal.Title>DSC validation</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Container>
                  <DSCValidationPage
                    Type={"VenderApproval"}
                    modal={() => handleApproveVendor(vendorId)}
                    close={handleDSCClose}
                    userData={userData}
                    token={token}
                    userDetail={userDetail}
                  />
                </Container>
              </Modal.Body>
            </Modal>
            <Modal
                      show={showRejectConsentModal}
                      onHide={()=>setShowRejectConsentModal(false)}
                      size="l"
                      centered
                      backdrop="static"
                      keyboard={false}
                    >
                      <Modal.Header>
                        <Modal.Title>Vendor Rejection Consent</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Container>
                          <div>
                            <div
                              className="d-flex"
                              style={{ alignItems: "baseline" }}
                            >
                              <label htmlFor="consent">
                                {" "}
                                &nbsp; Do you want to Reject the Vendor Approval Request?
                              </label>
                            </div>
                            <div className="d-flex justify-content-end mt-3">
                              <button
                                type="button"
                                className="btn  me-2 col-md-2 "
                                style={{backgroundColor:"red"}}
                                onClick={handleRejectModal}
                              >
                                Reject
                              </button>
                            </div>
                          </div>{" "}
                        </Container>
                      </Modal.Body>
                    </Modal>
          </div>
        </div>
      </div>
    </>
  );
}

export default VendorApproval;
